import React from 'react';
import Banner from './components/feed-banner';
import FeedPatients from './components/feed-patients';
import FeedEVisit from './feed-e-visit';
import { FeedSC } from './feed.styled';

const Feed: React.FC = () => {
  return (
    <FeedSC>
      <Banner />
      <FeedEVisit />
      <FeedPatients />
      {/* // Missing Add migrations*/}
      {/* <FeedAd />*/}
    </FeedSC>
  );
};

export default Feed;
